import { api } from "./apiClient";
import { User } from "@/types/user";

export const userService = {
  getUsers: () => api.get<User[]>("/users/"),
  
  getUser: (id: string) => api.get<User>(`/users/${id}`),
  
  getUsersByAcl: (acl: string) => api.get<User[]>(`/users/acl/${acl}`),

  getUsersByPuesto: (puesto: string) => api.get<User[]>(`/users/puesto/${puesto}`),

  getUserByName: (name: string) => api.get<User>(`/users/name/${name}`),
  
  createUser: (user: Partial<User>) => api.post<User>("/users/", user),

  updateUser: (id: string, user: Partial<User>) => api.put<User>(`/users/${id}`, user),

  resetPassword: (id: string, newPassword: string) =>
    api.put<User>(`/users/${id}/reset-password`, { newPassword }),
};
